module.exports = __webpack_public_path__ + "static/media/carbon_pin_filled.1522f148.svg";